const colors = { 
    primary: '#19144f', 
    secondary: '#58f3cd',
}

export default colors;